import { Navigate, useParams } from "react-router-dom";

/**
 * /communities/:slug now redirects to the unified detail template at
 * /neighbourhoods/:slug. Kept so previously-shared links (RentFaster,
 * Facebook, print) don't 404.
 */
export default function CommunityDetail() {
  const { slug } = useParams();
  return <Navigate to={`/neighbourhoods/${slug || ""}`} replace />;
}
